import { render, staticRenderFns } from "./ServerConfiguration.vue?vue&type=template&id=6b1af6ac"
import script from "./ServerConfiguration.vue?vue&type=script&lang=js"
export * from "./ServerConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ServerConfiguration.vue?vue&type=style&index=0&id=6b1af6ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports